import { Link } from 'react-router-dom';
import { categoryList } from '@/mocks/categories';

const quickLinks = [
  { label: '首页', to: '/' },
  { label: '电影', to: '/category/movie' },
  { label: '电视剧', to: '/category/tv' },
  { label: '综艺', to: '/category/variety' },
  { label: '搜索', to: '/search' },
  { label: '关于我们', to: '/about' },
];

export default function Footer() {
  return (
    <footer className="mt-20 bg-primary-950 text-background-100">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center">
                <i className="ri-play-fill text-lg" />
              </span>
              <span className="text-lg font-bold text-background-50">91在线视频</span>
            </div>
            <p className="mt-4 text-sm leading-7 text-background-200/80">
              专业的影视资源信息聚合与在线播放演示门户，覆盖最新电影、热播电视剧与综艺节目，
              用清晰的分类、筛选与搜索，帮你更快找到今晚想看的那一部。
            </p>
            <p className="mt-5 text-xs text-background-300/60 leading-6">
              本站为演示性质网站，页面内所有影视作品、演员与数据均为虚构示例，不涉及任何真实影视版权内容，
              亦不提供真实视频播放服务。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <Link to="/" className="hover:text-accent-400">快速导航</Link>
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-2 text-sm text-background-200/80">
              {quickLinks.map((item) => (
                <li key={item.to}>
                  <Link to={item.to} className="hover:text-accent-300 transition-colors whitespace-nowrap">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">
              <Link to="/category/movie" className="hover:text-accent-400">内容分类</Link>
            </h4>
            <ul className="mt-4 space-y-2 text-sm text-background-200/80">
              {categoryList.map((item) => (
                <li key={item.key}>
                  <Link to={item.path} className="flex items-center gap-1.5 hover:text-accent-300 transition-colors">
                    <i className={`${item.icon} text-xs`} />
                    <span>{item.label}</span>
                  </Link>
                </li>
              ))}
              <li className="text-xs text-background-300/60 pt-2">数据每周更新 · 演示版本</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-background-300/60">
            © 2026 91在线视频 · 演示站点 · 保留所有权利
          </p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-background-300/60">
            <Link to="/about" className="hover:text-accent-300 transition-colors whitespace-nowrap">版权声明</Link>
            <Link to="/about" className="hover:text-accent-300 transition-colors whitespace-nowrap">免责声明</Link>
            <Link to="/about" className="hover:text-accent-300 transition-colors whitespace-nowrap">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}